import { memo, useId } from 'react';
import '../../../../../../css/builder/page-builder.less';
import { useRouting } from '../../../../hooks/route';
import translations from '../../../../translations';
import type { Tab } from '../../../../types/tab';
import ConfirmModal from '../../../generic/modal/ConfirmModal';
import { useTabsDispatch } from '../../../tabs/TabsProvider';
import { PageEditorProvider } from '../PageEditorProvider';
import { ComposerProvider } from './composer/ComposerProvider';
import Main from './Main';

interface Props {
    tab: Tab;
    isActive: boolean;
}

const PageEditor = ({ tab, isActive }: Props) => {
    const containerId = useId();
    const { closeTabConfirmed } = useRouting();
    const dispatchTabs = useTabsDispatch();

    const pageBuilderClass = isActive
        ? 'nextgen-page-builder admin active'
        : 'nextgen-page-builder';

    const onCloseConfirm = () => {
        closeTabConfirmed(tab.key);
    };

    return (
        <PageEditorProvider
            containerId={containerId}
            tabKey={tab.key}
            showConfirmation={tab.showCloseConfirmation}
        >
            <ComposerProvider tabKey={tab.key}>
                <div id={containerId} className={pageBuilderClass} data-tab-content={tab.key}>
                    <Main tab={tab} isActive={isActive} />
                    <ConfirmModal
                        show={tab.showCloseConfirmation}
                        onCancel={() => {
                            dispatchTabs({
                                type: 'DISMISS_CLOSE_CONFIRMATION',
                                payload: { tabKey: tab.key },
                            });
                        }}
                        title={translations.TABS_close_page_layout}
                        messages={[
                            translations.TABS_page_unsaved_warning_1,
                            translations.TABS_page_unsaved_warning_2,
                        ]}
                        onConfirm={onCloseConfirm}
                        container={
                            document.querySelector(`[data-tab-content="${tab.key}"]`) as HTMLElement
                        }
                    />
                </div>
            </ComposerProvider>
        </PageEditorProvider>
    );
};

export default memo(PageEditor);
